module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Arquivo (formato csv de no máx. 4MB)",
      "columns": 6,
      "required": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "#!"
    },
    on: {
      "click": _vm.downloadExample
    }
  }, [_vm._v("Arquivo exemplo")]), _vm._v(" "), _c('upload-file', {
    attrs: {
      "validateFunction": _vm.validateFile,
      "data": _vm.uploadFileData
    },
    on: {
      "file": _vm.getFile
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef90ef92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/fileReprocessOrder/Options.vue
// module id = 3484
// module chunks = 0